// extracted by mini-css-extract-plugin
export default {"text":"EditSwitcher_text__Fja2T"};